import { render, staticRenderFns } from "./ujian.vue?vue&type=template&id=768ac859&"
import script from "./ujian.vue?vue&type=script&lang=js&"
export * from "./ujian.vue?vue&type=script&lang=js&"
import style0 from "./ujian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports